import React, { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Form, Row, Col, Button } from "react-bootstrap";
import TopNavigation from "../../components/TopNavigation";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import { Base } from "../../components/RootLayout";
import { getLocalStorage } from "../../utils/utilities";
import "./style.scss";

const initPayload = {
  email: "",
};
const defaultMessage =
  "Enter your email / phone and we will send you a link to reset your password";

const ForgotPage = (props) => {
  const [payload, setPayload] = useState(initPayload);
  const [current, setCurrent] = useState({
    welcome: true,
    isError: false,
    isSuccess: false,
    message: defaultMessage,
  });
  const slug = getLocalStorage("slug");

  const navigate = useNavigate();

  const resetLogin = async () => {
    if (current.isSuccess) {
      navigate(PageRoutes.login);
    } else {
      if (payload.email) {
        await props.resetPassword(payload).then((response) => {
          setCurrent({
            ...current,
            welcome: false,
            isSuccess: response.status === 200,
            isError: response.status !== 200,
            message:
              response.status !== 200
                ? `${response.message[0]}, please try again! `
                : "Reset information have been sent to your device.",
          });
        });
      } else {
        setCurrent({
          ...current,
          welcome: false,
          isError: true,
          message: "Email can not be empty, please try again!",
        });
      }
    }
  };

  return (
    <Base>
      <TopNavigation
        titlePage="Forgot Password"
        toPath={
          slug ? `${PageRoutes.loginOrgBySlug}/${slug}` : PageRoutes.login
        }
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
      />
      <Container className="mt-3">
        <Form>
          <div className="reset-info">
            {(current.welcome || current.isSuccess) && (
              <span>{current.message}</span>
            )}
            {current.isError && (
              <span style={{ color: "red" }}> {current.message}</span>
            )}
          </div>
          {!current.isSuccess && (
            <Row className="mb-3">
              <Form.Group as={Col}>
                <Form.Label>Email / Phone</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter Email / Phone"
                  className="form-control-without-border"
                  value={payload.email}
                  onChange={(e) => {
                    setPayload({ ...payload, email: e.target.value });
                  }}
                />
              </Form.Group>
            </Row>
          )}

          <Row className="mb-3">
            <Col>
              <Button
                variant="danger"
                className="btn-send"
                onClick={resetLogin}
              >
                {!current.isSuccess ? "Send" : "Back"}
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </Base>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  resetPassword: dispatch.ProfileSM.resetPassword,
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPage);
